'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/type.js
// module id = 191
// module chunks = 1